import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const colorArray = [
    'darkgrey',
    'green',
    'blue',
    'grey',
    'purple',
    'brown',
];

class ChartsOfListenersComp extends Component {
    static _convertTime(timestamp) {
        const date = new Date(timestamp);
        const month = `0${Number(date.getMonth() + 1)}`;
        const day = `0${date.getDate()}`;
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = `0${date.getMinutes()}`;
        const seconds = `0${date.getSeconds()}`;

        // Will display time in 10:30:23 format
        return (
            <p className="rowDate" key="date">
                {`${day.substr(-2)}/${month.substr(-2)}/${year} - ${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`}
            </p>
        );
    }

    constructor(props) {
        super(props);

        this.state = {
            reactVisLoaded: false,
            reactVisCurrentValue: null,
            reactVisCurrentIndex: null,
            graphMeta: [],
        };
    }

    componentDidMount() {
        if (!this.state.reactVisLoaded) {
            const css = document.createElement('link');

            css.rel = 'stylesheet';

            css.href = 'https://unpkg.com/react-vis/dist/style.css';

            document.head.appendChild(css);

            const aScript = document.createElement('script');

            aScript.type = 'text/javascript';

            aScript.src = 'https://unpkg.com/react-vis/dist/dist.min.js';

            document.head.appendChild(aScript);

            aScript.onload = () => {
                this.setState({
                    reactVisLoaded: true,
                });
            };
        }

        if (this.props.listenersData) {
            this._createGraphMeta(this.props.listenersData);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listenersData !== this.props.listenersData) {
            this._createGraphMeta(this.props.listenersData);
        }
    }


    _createGraphMeta(listenersData) {
        const tempGraphMeta = [];

        Object.keys(listenersData).map((key, index) => tempGraphMeta.push({ title: key, color: colorArray[index] }));

        this.setState({
            graphMeta: tempGraphMeta,
        });
    }

    _createSeries() {
        /**
         * the graph has an error, where warning complain of NaN, we believe is here
         */
        const listenersData = this.props.listenersData;
        const tempArray = [];

        Object.keys(listenersData).map((key, index) => {
            let min = false;
            let max = false;
            let sizeType = 'linear';
            const tempTempArray = listenersData[key].map((data, index2) => {
                let size = data.stddev || 5;
                let xData = data.x;

                if (this.props.dataType !== 'all') {
                    size = 5;

                    if (this.props.dataType === 'onlyMax') {
                        xData = data.max;
                    }

                    if (this.props.dataType === 'onlyMin') {
                        xData = data.min;
                    }
                } else if (index2 === 0) {
                    // initialize min and max
                    // eslint-disable-next-line no-multi-assign
                    min = max = data.stddev || 0;
                } else if (data.stddev < min) {
                    min = data.stddev;
                } else if (data.stddev > max) {
                    max = data.stddev;
                }

                return {
                    x: this.props.timeData[index2],
                    y: xData || 0, // to catch null values
                    size,
                    color: index2 === this.state.reactVisCurrentIndex ? 'red' : undefined,
                };
            });

            if (min === max) {
                // all points have the same size, use sizeType= 'literal'
                sizeType = 'literal';
            }

            if (tempArray.length === 0) {
                return tempArray.push(
                    // eslint-disable-next-line react/jsx-no-undef
                    <reactVis.LineMarkSeries
                        sizeRange={[5, 25]}
                        colorType="literal"
                        color={colorArray[index]}
                        key={key}
                        sizeType={sizeType}
                        data={tempTempArray}
                        onNearestX={(datapoint, event) => this.setState({ reactVisCurrentValue: datapoint, reactVisCurrentIndex: event.index })}
                    />,
                );
            }

            return tempArray.push(
                // eslint-disable-next-line react/jsx-no-undef
                <reactVis.LineMarkSeries
                    sizeRange={[5, 25]}
                    colorType="literal"
                    color={colorArray[index]}
                    key={key}
                    sizeType={sizeType}
                    data={tempTempArray}
                />,
            );
        });

        return tempArray;
    }


    _infoHint() {
        if (this.props.listenersData && this.state.graphMeta && typeof this.state.reactVisCurrentIndex === 'number') {
            return this.state.graphMeta.map((data, index) => {
                const x = this.props.listenersData[this.state.graphMeta[index].title][this.state.reactVisCurrentIndex].x;
                const max = this.props.listenersData[this.state.graphMeta[index].title][this.state.reactVisCurrentIndex].max;
                const min = this.props.listenersData[this.state.graphMeta[index].title][this.state.reactVisCurrentIndex].min;


                if (this.props.dataType === 'all' || this.props.dataType === 'total') {
                    const maxMin = (!Number.isNaN(max) && !Number.isNaN(min) && max !== min) ? `(max: ${max}, min: ${min})` : '';

                    return (
                        <li key={data.title}>
                            <span style={{ color: colorArray[index] }}> o </span>
                            {`${data.title}: ${x} ${maxMin}`}
                        </li>
                    );
                }

                if (this.props.dataType === 'onlyMax') {
                    return (
                        <li key={data.title}>
                            <span style={{ color: colorArray[index] }}> o </span>
                            {`${data.title} max: ${max}`}
                        </li>
                    );
                }

                if (this.props.dataType === 'onlyMin') {
                    return (
                        <li key={data.title}>
                            <span style={{ color: colorArray[index] }}> o </span>
                            {`${data.title} min: ${min}`}
                        </li>
                    );
                }

                if (this.props.dataType === 'onlyMean') {
                    return (
                        <li key={data.title}>
                            <span style={{ color: colorArray[index] }}> o </span>
                            {`${data.title} mean: ${x}`}
                        </li>
                    );
                }
            });
        }

        return null;
    }

    _showLegend() {
        if (this.props.legend) {
            return (
                // eslint-disable-next-line react/jsx-no-undef
                <reactVis.DiscreteColorLegend className="chartLegend" orientation="horizontal" items={this.state.graphMeta} />
            );
        }

        return null;
    }


    render() {
        return (
            !this.state.reactVisLoaded
                ? 'loading...'
                :
                // eslint-disable-next-line react/jsx-no-undef
                <reactVis.XYPlot
                    className="chartsListener"
                    margin={{ left: 50 }}
                    width={this.props.chartWidth}
                    height={this.props.chartHeight}
                    xType="time"
                    onMouseLeave={() => this.setState({ reactVisCurrentValue: null, reactVisCurrentIndex: null })}
                >
                    {this._showLegend()}
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <reactVis.HorizontalGridLines />
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <reactVis.VerticalGridLines />

                    {this.props.listenersData ? this._createSeries() : ''}
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <reactVis.XAxis />
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <reactVis.YAxis />
                    {
                        this.state.reactVisCurrentValue &&
                        // eslint-disable-next-line react/jsx-no-undef
                        <reactVis.Hint
                            value={this.state.reactVisCurrentValue}
                        >
                            <div className="contentHint">
                                {this.constructor._convertTime(this.state.reactVisCurrentValue.x)}
                                <ul className="listHint">
                                    {this._infoHint()}
                                </ul>
                            </div>
                        </reactVis.Hint>
                    }
                </reactVis.XYPlot>
        );
    }
}

ChartsOfListenersComp.propTypes = exact({
    timeData: PropTypes.array.isRequired,
    listenersData: PropTypes.object.isRequired,
    chartWidth: PropTypes.number.isRequired,
    chartHeight: PropTypes.number.isRequired,
    legend: PropTypes.bool.isRequired,
    dataType: PropTypes.string.isRequired,
});

export default ChartsOfListenersComp;
